import { extractArrayFromQuery } from '../../../utils/query-utils';

export default {
  param: extractArrayFromQuery,
  query: function(values) {
    if (values.length > 0) {
      return {
        $or: [
          {
            project: {
              $where: {
                activityId: {
                  $in: values
                }
              }
            }
          },
          {
            event: {
              $where: {
                activityId: {
                  $in: values
                }
              }
            }
          }
        ]
      }
    }
  }
}
